// @flow
import * as React from 'react';
import Box from 'components/Box';
import { colors, fontWeights } from 'theme';

export type Status = 'NEW';

const getStatus: Status => {
  theme: { bg: string, color: string },
  label: string
} = status => {
  switch (status) {
    case 'NEW':
    default:
      return {
        theme: {
          color: 'white',
          bg: colors.waterBlue
        },
        label: getText('New')
      };
  }
};

export const StatusTag = (props: Object) => (
  <Box
    data-qa-id="listing-status"
    display="inline-block"
    py="3px"
    px="5px"
    borderRadius="4px"
    letterSpacing="1px"
    textTransform="uppercase"
    lineHeight={1}
    fontWeight={fontWeights.semiBold}
    fontSize={11}
    {...props}
  />
);

export default ({ status }: { status: Status }) => {
  const { theme, label } = getStatus(status);
  return (
    <StatusTag mb={12} {...theme}>
      {label}
    </StatusTag>
  );
};
